// src/MembersLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

export default function MembersLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Store user in Firestore (optional update on login)
      await setDoc(
        doc(db, "subscribers", user.email),
        {
          email: user.email,
          lastLogin: serverTimestamp(),
        },
        { merge: true }
      );

      localStorage.setItem("isSubscribed", "true");
      localStorage.setItem("userEmail", user.email);
      navigate("/membersdashboard");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-white">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">🔐 Members Login</h1>

      <form onSubmit={handleLogin} className="w-full max-w-sm space-y-4">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 border rounded-md shadow"
          required
        />
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 border rounded-md shadow"
          required
        />
        <button
          type="submit"
          className="w-full bg-purple-600 text-white py-2 rounded-md hover:bg-purple-700"
        >
          Log In
        </button>
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
      </form>

      <p className="mt-2 text-sm text-gray-600">
        Forgot your password?{" "}
        <a
          href="/reset-password"
          className="text-purple-600 underline hover:text-purple-800"
        >
          Click here
        </a>
      </p>

      <p className="mt-6 text-sm text-gray-600">
        Not a member?{" "}
        <a
          href="/offer"
          className="text-purple-600 underline hover:text-purple-800"
        >
          Join here
        </a>
      </p>
            <p className="mt-4 text-sm text-gray-600">
  ←{" "}
  <a
    href="https://realsautomated.com"
    className="text-purple-600 underline hover:text-purple-800"
  >
    Return to Main Site
  </a>
</p>
    </div>
  );
}
